import { InputAdornment, Stack, Typography } from '@mui/material'
import stuart from '../Assets/Images/Stuart.png'

import packageJson from '../../package.json'
import { Box } from '@mui/system'
import { ReadOnlyTextField } from '../garvan-react/Components/ReadOnlyTextField'
import { useUserContext } from '../Contexts/UserConfig'
import { Architecture, DesignServices } from '@mui/icons-material'
import { stackGap } from '../Constants&Theme/Spacing'

const About = () => {
  const { whoAmI } = useUserContext()

  let dependencies = ''
  Object.keys(packageJson.dependencies).forEach((item) => {
    dependencies = dependencies + item + '\n'
  })

  return (
    <Box
      sx={{
        maxWidth: 'md',
        width: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          verticalAlign: 'middle',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <img
          src={stuart}
          alt="stuart"
          style={{ marginRight: '20px', width: '150px', height: '150px' }}
        />
        <div style={{ display: 'inline' }}>
          <Typography
            variant="h4"
            style={{ fontWeight: 800 }}
          >
            {packageJson.shortName}
          </Typography>
          <Typography
            variant="h6"
            style={{ fontWeight: 300 }}
          >
            Garvan Institute of Medical Research
          </Typography>
        </div>
      </Box>
      <Stack
        width={1}
        gap={stackGap.col}
      >
        <Stack
          direction={'row'}
          width={1}
          gap={stackGap.row}
        >
          <ReadOnlyTextField
            label="Environment"
            value={process.env.REACT_APP_UI_NAME}
            fullWidth
          />
          <ReadOnlyTextField
            label="Database"
            value={whoAmI?.db || ''}
            fullWidth
          />
          <ReadOnlyTextField
            label="Version"
            value={packageJson.version}
            fullWidth
          />
        </Stack>
        <Stack
          direction={'row'}
          width={1}
          gap={stackGap.row}
        >
          <Stack
            width={1}
            gap={stackGap.col}
          >
            <ReadOnlyTextField
              label="Solutions Architect"
              value={'Peter Modica'}
              fullWidth
              sx={{ mr: 1 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Architecture />
                  </InputAdornment>
                ),
              }}
            />
            <ReadOnlyTextField
              label="Frontend Developer"
              value={'Adrian Metlenko'}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <DesignServices />
                  </InputAdornment>
                ),
              }}
            />
            <ReadOnlyTextField
              label="Past Developers"
              value={
                'Denia Mang, \nFrank Pace, \nGerard Hammond, \nJim MicBride, \nMilton Lai'
              }
              multiline
              fullWidth
            />
          </Stack>
          <ReadOnlyTextField
            label="Dependency Credits"
            value={dependencies.trimEnd()}
            multiline
            fullWidth
          />
        </Stack>
      </Stack>
    </Box>
  )
}

export default About
